module.exports = __webpack_public_path__ + "static/media/SpringVille_PH1_2.ab822b0c.webp";